import styled, { css } from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 40px;

  @media only screen and (max-width: 767px) {
    padding: 0 20px;
    text-align: center;
  }

  ${({ areFiltersAvailable, filterDirection }) => `
  ${css`
    @media (min-width: 650px) {
      margin-top: ${filterDirection === "horizontal" && areFiltersAvailable
        ? "45px"
        : "0"};
    }
  `}`}
`;
